type Props = {
  averageTime: number
}

export const getCleanlinessOfHands = ({ averageTime }: Props): number => {
  return (averageTime * 100) / 40
}
